import { render, staticRenderFns } from "./IconMembershipStatus.vue?vue&type=template&id=541540bc"
import script from "./IconMembershipStatus.vue?vue&type=script&lang=js"
export * from "./IconMembershipStatus.vue?vue&type=script&lang=js"
import style0 from "./IconMembershipStatus.vue?vue&type=style&index=0&id=541540bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports